var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "results" } }, [
    _vm.$root.fittings.length
      ? _c(
          "div",
          [
            _c("p", [
              _vm._v(
                "\n      Below are " +
                  _vm._s(_vm.$root.isBottomType ? "bottoms" : "bras") +
                  " recommended just\n      for you!\n    "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "flex",
                staticStyle: {
                  "justify-content": "space-around",
                  "flex-wrap": "wrap",
                  gap: "10px",
                },
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _vm.$root.filters.length ? _c("filters") : _vm._e(),
                    _vm._v(" "),
                    _c("sort_by"),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.$root.fittings, function (product) {
              return _c("result", {
                key: product.shopify_id,
                attrs: { product: product },
              })
            }),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$root.fittings && !_vm.$root.fittings.length
      ? _c("p", [
          _vm._v("\n    Sorry, no products match your search!"),
          _c("br"),
          _vm._v(
            "\n    Please message us using the Contact Us tab or send us a message via our\n    Facebook/Instagram so we can help you find a perfect\n    " +
              _vm._s(_vm.$root.isBottomType ? "bottom" : "bra") +
              ".\n  "
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.$root.fittings ? _c("p", [_vm._v("Loading...")]) : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "confidence-container" }, [
      _c("div", { staticClass: "confidence-table" }, [
        _c("div", { staticClass: "flex" }, [
          _c("div", { staticStyle: { width: "115px" } }, [
            _vm._v("VERY HIGH -"),
          ]),
          _vm._v(" "),
          _c("div", [_vm._v("Above 90% fit confidence")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex" }, [
          _c("div", { staticStyle: { width: "115px" } }, [_vm._v("HIGH -")]),
          _vm._v(" "),
          _c("div", [_vm._v("70% - 89.9% fit confidence")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }